import React from 'react';

const CrossIcon = ({ colour = '#6021B3', width = '12', height = '12', onClick = (e) => {} }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={onClick}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 1.2L10.8 0L6 4.8L1.2 0L0 1.2L4.8 6L0 10.8L1.2 12L6 7.2L10.8 12L12 10.8L7.2 6L12 1.2Z"
                fill={colour}
            />
        </svg>
    );
};

export default CrossIcon;
